export class PsOrigin {

    _companyId; // number | undefined
    _workerId; // number | undefined
    _machineId; // number | undefined
    _documentId; // number | undefined
    _fromMyContractors = false; // boolean

    constructor(
        companyId,
        workerId,
        machineId,
        documentId,
        fromMyContractors,
    ) {
        this._companyId = companyId;
        this._workerId = workerId;
        this._machineId = machineId;
        this._documentId = documentId;
        this._fromMyContractors = fromMyContractors;
    }

    static fromValues(
        {
            companyId,
            workerId,
            machineId,
            documentId,
            fromMyContractors,
        },
    ) {
        return new this(
            companyId,
            workerId,
            machineId,
            documentId,
            fromMyContractors,
        );
    }

    companyId() {
        return this._companyId;
    }

    hasCompany() {
        return !!this.companyId();
    }

    workerId() {
        return this._workerId;
    }

    hasWorker() {
        return !!this.workerId();
    }

    machineId() {
        return this._machineId;
    }

    hasMachine() {
        return !!this.machineId();
    }

    documentId() {
        return this._documentId;
    }

    hasDocument() {
        return !!this.documentId();
    }

    isFromMyContractors() {
        return this._fromMyContractors;
    }

    isFromMyOutsources() {
        return !this._fromMyContractors;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/model/PsOrigin.js